export default __webpack_public_path__ + "static/1580-f32e812636078f1a40849385b358e53f.gif";